<template>
    <div>
        <!-- TODO: make info item as component, and replace it in summary -->
        <div class="custom-info-item">
            <span class="custom-info-item__label">Ticket #</span>
            <span class="custom-info-item__value">{{ ticketNumber }}</span>
        </div>
        <div class="custom-info-item">
            <span class="custom-info-item__label">{{ $t('LBL_HELPDESK_OPENED_DATE') }}</span>
            <span class="custom-info-item__value">{{ transformOpenedTime }}</span>
        </div>
        <div class="custom-info-item custom-info-item--assigned-to">
            <avatar :record="assignedTo.value"></avatar>
            <span class="custom-info-item__label">{{ $t('LBL_HELPDESK_ASSIGNED_TO') }}</span>
            <span class="custom-info-item__value">{{ assignedTo.displayValue }}</span>
        </div>
        <hr v-if="customFields.length">
        <div v-for="field in customFields" :key="field.id" class="custom-info-item">
            <custom-field :field="field"></custom-field>
        </div>
        <hr v-if="attachments.length">
        <div v-if="attachments.length" class="custom-info-item custom-info-item--attachment">
            <span class="custom-info-item__label custom-info-item--attachment__label">{{ $t('LBL_ATTACHED_FILES') }}</span>
            <span v-for="thumbnail in thumbnails" :key="thumbnail.id" @click.capture="attachmentClicked(thumbnail)"
                  class="custom-info-item__value custom-info-item--attachment__value">
                   <lightbox :images="[thumbnail]" :nav="false"
                   >
                <template v-slot="{ image }">
                    <i class="zmdi zmdi-attachment-alt"/>{{ image.name }}
                </template>
            </lightbox>
                       </span>
        </div>
    </div>
</template>

<script>

    import Avatar from "@/components/Avatar"
    import Lightbox from '@/components/Lightbox'
    import CustomField from '@/components/CustomField'
    import AppMixin from "@/mixins/AppMixin";

    export default {
        mixins: [AppMixin],
        components: {
            Avatar,
            Lightbox,
            CustomField
        },
        computed: {
            transformOpenedTime() {
                return this.getLocaltime(this.openedDate)
            }
        },
        data() {
            return {
                assignedToAvatar: '',
                thumbnails: []
            }
        },

        props: [
            'ticketNumber',
            'openedDate',
            'customFields',
            'attachments',
            'assignedTo'
        ],

        methods: {
            attachmentClicked(attachment, e) {
                if (!attachment.src)
                    this.$emit('attachment-clicked', attachment)
            }
        },
        watch: {
            attachments: async function (val, oldVal) {
                const tempVal = [...val]
                for (let i = 0; i < tempVal.length; i++) {
                    const item = tempVal[i]
                    let blob;
                    if (item.ext === 'png' || item.ext === 'jpeg' || item.ext === 'jpg') {
                        const response = await Api.download(item.id, true)
                        if (!response) {
                            return
                        }
                        blob = new Blob([response])
                    }
                    let obj = this.thumbnails.find(i => item.id === i.id);
                    if (!obj)
                        this.thumbnails.push({
                            id: item.id,
                            name: item.name,
                            src: blob ? window.URL.createObjectURL(blob) : ''
                        })
                }
            }
        }

    }
</script>
<style lang="scss">@import "@/assets/scss/components/HelpDesk/Detail/_custom.scss";</style>